import DefaultLayout from "layout/DefaultLayout/DefaultLayout";
import "layout/DefaultLayout/DefaultLayout.scss";

export default DefaultLayout;
